import { render, staticRenderFns } from "./ModalEditLocationSocial.vue?vue&type=template&id=23f3c24e"
import script from "./ModalEditLocationSocial.vue?vue&type=script&lang=js"
export * from "./ModalEditLocationSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports